import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Component, Input, model } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.css',
  imports: [CommonModule, FormsModule]
})
export class CheckboxComponent {
  valor = model<boolean>(false);
  @Input() etiqueta = 'Inserte etiqueta';
  @Input() readonly = false;
  @Input() center = true;
}
